import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';
export const MONTHLY_REPORT_TYPES = [
]

const entityColumns = {
  id: {
    model_name: 'MonthlyReport',
    column_type: 'id',
  },
  created_at: {
    model_name: 'MonthlyReport',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'MonthlyReport',
    column_type: 'datetime',
  },
  author_type: {
    model_name: 'MonthlyReport',
    column_type: 'string',
  },
  title: {
    model_name: 'MonthlyReport',
    column_type: 'string',
  },
  type: {
    model_name: 'MonthlyReport',
    column_type: 'type',
    extra: {
      options: [],
    },
  },
  author: {
    model_name: 'MonthlyReport',
    column_type: 'belongs_to',
    extra: {
      polymorphic: true,
      association_name: 'author',
      model_name: '',
      foreign_key: 'author_id',
    },
  },
  author_id: {
    model_name: 'MonthlyReport',
    column_type: 'belongs_to',
    extra: {
      polymorphic: true,
      association_name: 'author',
      model_name: '',
      foreign_key: 'author_id',
    },
  },
  fund: {
    model_name: 'MonthlyReport',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'fund',
      model_name: 'Fund',
      foreign_key: 'fund_id',
    },
  },
  fund_id: {
    model_name: 'MonthlyReport',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'fund',
      model_name: 'Fund',
      foreign_key: 'fund_id',
    },
  },
  published_at: {
    model_name: 'MonthlyReport',
    column_type: 'datetime',
  },
  content_type: {
    model_name: 'MonthlyReport',
    column_type: 'enum',
  },
  announced_at: {
    model_name: 'MonthlyReport',
    column_type: 'datetime',
  },
  content: {
    model_name: 'MonthlyReport',
    column_type: 'text',
  },
  markdown_content: {
    model_name: 'MonthlyReport',
    column_type: 'text',
  },
  pdf_file: {
    model_name: 'MonthlyReport',
    column_type: 'attached',
    extra: {
      size: 20,
    },
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
